import { render } from "./DraftOverview.vue?vue&type=template&id=6e6263dc&scoped=true"
import script from "./DraftOverview.vue?vue&type=script&lang=js"
export * from "./DraftOverview.vue?vue&type=script&lang=js"

import "./DraftOverview.vue?vue&type=style&index=0&id=6e6263dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e6263dc"]])

export default __exports__